import { mapState, mapGetters, mapActions } from 'vuex'

// auth

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', [
    'loggedIn',
    'accessClaims',
    'refreshClaims',
    'accessToken',
    'limitedAccess',
    'fullAccess',
    'serializedUser',
    'getPatient',
    'getProfessional',
    'getShowProfile',
    'getWizard',
    'hasMfa',
    'isMfaGoogle',
    'isMfaEmail',
    'defaultProfilePhoto',
    'darkMode',
    'language',
    'isWizardComplete',
    'isWizardMinimized',
    'wizardStatus',
    'settings',
  ]),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'addMfaDevice',
  'removeMfaDevice',
  'setProfilePicture',
  'removeProfilePicture',
  'updateUserSettings',
  'fetchWizardData',
  'updateWizardStep',
])

// nav

export const navComputed = {
  ...mapState('nav', {
    navDrawer: (state) => state.navDrawer,
    calendarDrawer: (state) => state.calendarDrawer,
    settingsDrawer: (state) => state.settingsDrawer,
  }),
  ...mapGetters('nav', ['getDrawer']),
}

export const navMethods = mapActions('nav', ['setDrawer'])

// library

export const libraryComputed = {
  ...mapState('library', { map: (state) => state.map }),
  ...mapGetters('library', ['getFolder']),
}

export const libraryMethods = mapActions('library', [
  'setFolder',
  'unsetFolder',
])

// lang

export const langComputed = {
  ...mapGetters('lang', ['locales', 'fullLocale']),
}

// options

export const optionsComputed = {
  ...mapGetters('options', [
    'getConditionOptions',
    'getSymptomOptions',
    'getAllergyOptions',
    'getSurgeryOptions',
    'getProcedureOptions',
    'getUserOptions',
    'getPatientOptions',
    'getImmunizationOptions',
    'getFamilyHistoryOptions',
    'getSocialHistoryOptions',
    'getMedicationOptions',
    'getMedicalVisitOptions',
    'getSupplementOptions',
    'getCalendarOptions',
    'getTravelHistoryOptions',
    'getDiagnosticOptions',
    'getLabOptions',
  ]),
}

export const optionsMethods = mapActions('options', [
  'setConditionOptions',
  'setAllergyOptions',
])

// Choices
export const choicesComputed = {
  ...mapGetters('choices', ['getLabUnits']),
}

export const choicesMethods = mapActions('choices', ['setLabUnits'])
